<template>
  <li :class="['nitem', { unread: !n.read, team: team }]" @click="$emit('open', n)">
    <span class="icon" aria-hidden="true">{{ icon }}</span>
    <div class="content">
      <p class="title">{{ n.title }}</p>
      <p v-if="n.body" class="body"><ComponentRichText :text="n.body" @link="(u) => $emit('link', n, u)" /></p>
      <div v-if="actions.length" class="acts">
        <button v-for="(a, i) in actions" :key="i" type="button" :class="i === 0 ? 'act primary' : 'act'" @click.stop="$emit('action', n, a, i === 0 ? 'primary' : 'secondary')">{{ a.label }}</button>
      </div>
      <p class="time">{{ time }}</p>
    </div>
    <button v-if="!n.read" type="button" class="mark" title="Marcar como lida" aria-label="Marcar como lida" @click.stop="$emit('read', n)">✓</button>
  </li>
</template>

<script>
import ComponentRichText from "@/components/ComponentRichText.vue";
import { cleanActions } from "@/utils/richText";
import { ago, kindIcon, TEAM_LIKE } from "@/utils/notifications";

export default {
  name: "ComponentNotificationItem",
  components: { ComponentRichText },
  props: { n: { type: Object, required: true } },
  emits: ["open", "link", "action", "read"],
  computed: {
    icon() { return kindIcon(this.n.kind); },
    team() { return TEAM_LIKE.includes(this.n.kind); },
    actions() { return cleanActions(this.n.actions); },
    time() { return ago(this.n.created_at); },
  },
};
</script>

<style scoped>
.nitem { display: flex; gap: 0.7em; padding: 0.8em 1em; border-bottom: 1px solid #f2f4f5; cursor: pointer; list-style: none; position: relative; background: #fff; }
.nitem:hover { background: #f7fbfc; }
.nitem.unread { background: #f0fbfd; box-shadow: inset 3px 0 0 #29b1cc; }
.nitem.unread.team { background: #f5f2ff; box-shadow: inset 3px 0 0 #7a5af5; }
.icon { flex: 0 0 32px; width: 32px; height: 32px; border-radius: 50%; background: #eef6f8; display: flex; align-items: center; justify-content: center; font-size: 16px; }
.nitem.unread .icon { background: #fff; box-shadow: 0 0 0 1px #cfe9ef; }
.content { flex: 1; min-width: 0; }
.title { margin: 0; font-size: 0.9em; color: #222; line-height: 1.35; }
.nitem.unread .title { font-weight: 700; }
.body { margin: 0.25em 0 0; font-size: 0.82em; color: #5b666b; line-height: 1.45; }
.time { margin: 0.35em 0 0; font-size: 0.75em; color: #8a969b; }
.acts { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 0.6em; }
.act { border: 1px solid #29b1cc; background: #fff; color: #1a8ea8; border-radius: 8px; padding: 7px 12px; font-weight: 700; font-size: 0.82em; cursor: pointer; min-height: 34px; }
.act.primary { background: #29b1cc; color: #fff; }
.mark { flex: none; align-self: flex-start; width: 32px; height: 32px; border-radius: 50%; border: 1px solid #d5e3e6; background: #fff; color: #1a8ea8; cursor: pointer; font-weight: 700; }
.mark:hover { background: #eaf7fa; }
</style>
